class IdNameEntity {
    constructor({ id, name }) {
        this.id = id
        this.name = name
    }
}

export { IdNameEntity }
